var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInvitationLinkIcon = function SvgInvitationLinkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-12{fill:#0097ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M14.59,11.41a1,1,0,0,1-1.41,1.41,2,2,0,0,0-.57-.38,1.82,1.82,0,0,0-1.34,0,2,2,0,0,0-.57.38L8.93,14.59a1.56,1.56,0,0,0-.37.57,1.71,1.71,0,0,0-.14.67,2,2,0,0,0,.13.67,1.79,1.79,0,0,0,.38.56,1.73,1.73,0,0,0,1.91.39,1.84,1.84,0,0,0,.57-.38l1.24-1.24a.92.92,0,0,1,.52-.26,3.38,3.38,0,0,1-.54-.17,3.72,3.72,0,0,1-1.22-.81,1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0,2,2,0,0,0,.57.38,1.78,1.78,0,0,0,1.34,0,1.75,1.75,0,0,0,.57-.37l1.77-1.77a1.84,1.84,0,0,0,.38-.57,1.79,1.79,0,0,0,0-1.34,1.75,1.75,0,0,0-.95-.95,1.76,1.76,0,0,0-1.91.38l-1.24,1.24a1,1,0,0,1-.52.26,3.35,3.35,0,0,1,.54.16A3.8,3.8,0,0,1,14.59,11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm6.29,11.6a3.72,3.72,0,0,1-.81,1.22l-1.77,1.77a3.58,3.58,0,0,1-1.21.81,3.78,3.78,0,0,1-1.44.29l-.24,0a1,1,0,0,1,.24.17,1,1,0,0,1,0,1.41l-1.24,1.24a3.72,3.72,0,0,1-1.22.81,3.65,3.65,0,0,1-1.43.29,3.74,3.74,0,0,1-3.46-2.32,3.7,3.7,0,0,1,0-2.87,3.83,3.83,0,0,1,.81-1.22l1.77-1.76a3.58,3.58,0,0,1,1.21-.81,3.78,3.78,0,0,1,1.69-.27.82.82,0,0,1-.25-.16,1,1,0,0,1,0-1.41l1.24-1.24a3.57,3.57,0,0,1,1.22-.81,3.78,3.78,0,0,1,2.86,0,3.91,3.91,0,0,1,1.22.82,3.57,3.57,0,0,1,.81,1.22,3.67,3.67,0,0,1,0,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M12.83,10.43a5,5,0,0,0-.64-.1A1,1,0,0,0,12.83,10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M13.17,15.57a3.51,3.51,0,0,0,.65.09A1.05,1.05,0,0,0,13.17,15.57Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvitationLinkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InvitationLinkIcon.72196771.svg";
export { ForwardRef as ReactComponent };